import React, {useState, useEffect, useContext, useRef} from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonFooter, IonText, IonInput } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import '../../../css/layout.css';

import { AddScopeModal } from './Modal_Add_Scope';
import { ShowScopePicsModal } from './Modal_ShowScopePics';
import {AddExpenseInvoiceModal} from './Modal_AddExpense_Invoice';
import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';


export function ConsultationDetailsModal(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewConsultationDetailData, setViewConsultationDetailData] = useState([]);


    let [consultationID, setConsultationID] = useState(props.data.consultationID);
    let [consultationStatus, setConsultationStatus] = useState(null);

    let [viewScopeList, setViewScopeList] = useState([]);
    let [viewScopeEstimates, setViewScopeEstimates] = useState([]);
    let [viewScopeExpenses, setViewScopeExpenses] = useState([]);
    let [scopePicsModal, setScopePicsModal] = useState(false);
    let [scopePicsModal_finished, setScopePicsModal_finished] = useState(false);
    let [showAddScopeModal, setShowAddScopeModal] = useState(false);

    let [createScopeName, setCreateScopeName] = useState('');
    let [createScopeDescription, setCreateScopeDescription] = useState('');

    let [workmanshipTotal, setWorkmanshipTotal] = useState('');

    let [showAddExpenseModal, setShowAddExpenseModal] = useState(false);

    let [estimateLineNumber, setEstimateLineNumber] = useState(null);
    let [viewInvoice, setViewInvoice] = useState(false);
    let [invoiceID, setInvoiceID] = useState('');
    let [invoiceForm, setInvoiceForm] = useState('');

    const slidesRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);



    const parseArray = (raw) => {
    try {
        let v = raw;
        if (typeof v === "string") v = JSON.parse(v);
        while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
        return Array.isArray(v) ? v : [];
    } catch {
        console.warn("Bad itemID_list JSON:", raw);
        return [];
    }
    };


   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_consultation_details',
                    user: acctID,
                    xConsultationID: props.data.consultationID,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                let consultationCols = rows[0].split('|');

                    setConsultationID(consultationCols[0]);
                    setConsultationStatus(consultationCols[10]);
                    setInvoiceID(consultationCols[11]);
                    setInvoiceForm(consultationCols[12]);


                for (let rownum = 1; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setViewScopeList((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            consultationID: cols[0],
                            scopeNumber: cols[1],
                            scopeName: cols[3],
                            scopeDescription: cols[4],
                            workmanshipTotal: cols[5],
                            scopeExpenses: cols[6],
                            dateLogged: cols[7],
                            assigned: cols[8],
                            lastModified: cols[9],
                            status: cols[10],
                            scopePic1: cols[11],
                            scopePic2: cols[12],
                            scopePic3: cols[13],
                            scopePic4: cols[14],
                            scopePic1_finished: cols[15],
                            scopePic2_finished: cols[16],
                            scopePic3_finished: cols[17],
                            scopePic4_finished: cols[18],
                            scope_items: parseArray(cols[19]),
                        })
                    });


                        /*let cols_estimates = cols[2].split('#');

                        setViewScopeEstimates((prevAvailableRooms) => {
                            return prevAvailableRooms.concat({
                                consultationID: cols_estimates[0],
                                scopeNumber: cols_estimates[1],
                                estimateLineNumber: cols_estimates[2],
                                itemID: cols_estimates[3],
                                itemName: cols_estimates[4],
                                itemDescription: cols_estimates[5],
                                itemQuantity: cols_estimates[6],
                                itemEstimatedPrice: parseFloat(cols_estimates[7]).toFixed(2),

                            })
                        });


                        let cols_expenses = cols[2].split('$');

                        setViewScopeExpenses((prevAvailableRooms) => {
                            return prevAvailableRooms.concat({
                                consultationID: cols_expenses[0],
                                scopeNumber: cols_expenses[1],
                                expenseLineNumber: cols_expenses[2],
                                itemID: cols_expenses[3],
                                itemName: cols_expenses[4],
                                itemDescription: cols_expenses[5],
                                itemQuantity: cols_expenses[6],
                                itemPrice: parseFloat(cols_expenses[7]).toFixed(2),

                            })
                        });*/

                } 
            })
        
    }, []);

    function deleteScope(event)
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_delete_scope',
                user: acctID,
                xConsultationID: props.data.consultationID,
                xScopeLineNumber: event[1],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function deleteScopeItem_estimate(event)
    {



        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_delete_scopeItem_estimate',
                user: acctID,
                xConsultationID: props.data.consultationID,
                xScopeLineNumber: props.data.scopeLineNumber,
                xScopeItem_estimateLineNumber: estimateLineNumber,
                sessionID: sessionID,

            }),
        }


        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function send_customer_approvalRequest()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_send_customerApproval',
                user: acctID,
                xConsultationID: props.data.consultationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }
    
    function add_consultationToProject()
    {
        alert("In Function add_consultationToProject");
    }
    function convert_consultationToProject()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_convert_to_project',
                user: acctID,
                xConsultationID: props.data.consultationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function viewExpenseDetailsHandler(event) {


        //setExpenseID(event[1]);
        //setTotalAmount(event[2]);

        //setShowExpenseDetailsModal(event[0]);
    }

  const slideTo = async (index) => {
    if (slidesRef.current) {
      await slidesRef.current.slideTo(index);
      setActiveIndex(index);
    }
  };

  const onSlideChange = async () => {
    const index = await slidesRef.current.getActiveIndex();
    setActiveIndex(index);
  };

    function closeModalHandler() {

        setViewConsultationDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader style={{color: 'black'}}>
            <IonGrid >
                    <IonRow>
                        <IonCol> Consultation ID</IonCol>
                        <IonCol> {props.data.consultationID} </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => setShowAddScopeModal(true)}>Add Scope</IonButton>
                        </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <IonContent className='gridContent_multiple_top'>
        
        <IonRow className="slide-index-row">
        {viewScopeList.map((_, index) => (
          <IonCol key={index} size="auto">
            <IonButton
              fill={activeIndex === index ? 'solid' : 'outline'}
              color={activeIndex === index ? 'primary' : 'medium'}
              className="slide-index-btn"
              onClick={() => slideTo(index)}
            >
              {index + 1}
            </IonButton>
          </IonCol>
        ))}
      </IonRow>

        <IonSlides pager='false' options={{direction: 'horizontal'}} ref={slidesRef} onIonSlideDidChange={onSlideChange}>

        {viewScopeList.map((detailData) =>   {
        return (
        <IonSlide key={detailData.scopeNumber}>

                    <IonGrid className='gridContent_multiple_top_grid'>
                                            <IonRow>
                                                <IonCol size='6'>
                                                    <IonText for='searchSupplierName'>Scope Name:</IonText>
                                                </IonCol>
                                                <IonCol size='6'>
                                                    {/*<IonInput className='professional-input' type='text' value={ createScopeName }  placeholder='Enter Scope Name' autocomplete='off' onIonChange={(e) => setCreateScopeName(e.target.value)} required></IonInput>*/}
                                                    <IonText className='professional-text'>{ detailData.scopeName }</IonText>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol size='6'>
                                                    <IonText for='searchSupplierName'>Description:</IonText>
                                                </IonCol>
                                                <IonCol size='6'>
                                                    {/*<IonInput className='professional-input' type='text' value={ createScopeDescription }  placeholder='Enter Scope Name' autocomplete='off' onIonChange={(e) => setCreateScopeDescription(e.target.value)} required></IonInput>*/}
                                                    <IonText className='professional-text'>{ detailData.scopeDescription }</IonText>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol size='6'>
                                                    <IonText for='searchSupplierName'>Workmanship:</IonText>
                                                </IonCol>
                                                <IonCol size='6'>
                                                    {/*<IonInput className='professional-input' type='text' value={ workmanshipTotal }  placeholder='Enter Scope Name' autocomplete='off' onIonChange={(e) => setWorkmanshipTotal(e.target.value)} required></IonInput>*/}
                                                    <IonText className='professional-text'>{ detailData.workmanshipTotal }</IonText>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow >
                                                <IonCol >Invoice</IonCol>
                                                <IonCol >{"FILE"}</IonCol>
                                                <IonCol >
                                                    <IonButton  onClick={() => setViewInvoice(true)}> View </IonButton>
                                                </IonCol>

                                            {viewInvoice == true && <ViewInvoiceModal openModal={ viewInvoice } closeModal={() => setViewInvoice(false)} data={{
                                                                    fileLocation: `/api/form/${invoiceForm}/${schema}`, 
                                                                    }}></ViewInvoiceModal>}
                                            </IonRow>
                                            <IonRow >
                                                <IonCol >Images Before</IonCol>
                                                <IonCol >{detailData.assigned}</IonCol>
                                                <IonCol >
                                                    <ShowScopePicsModal openModal={ scopePicsModal } closeModal={() => setScopePicsModal(false)} data={{
                                                    scopePic1: detailData.scopePic1, 
                                                    scopePic2: detailData.scopePic2, 
                                                    scopePic3: detailData.scopePic3, 
                                                    scopePic4: detailData.scopePic4, 
                                                    scopeNumber: detailData.scopeNumber, 
                                                    scopeEstimateAmount: detailData.scopeEstimateAmount,
                                                    scopeExpenses: detailData.scopeExpenses,
                                                    consultationID: props.data.consultationID
                                                    }}></ShowScopePicsModal>
                                                    <IonButton onClick={() => setScopePicsModal(true)}> Add/View </IonButton>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow >
                                                <IonCol >Images After</IonCol>
                                                <IonCol >{detailData.assigned}</IonCol>
                                                <IonCol >
                                                    <ShowScopePicsModal openModal={ scopePicsModal_finished } closeModal={() => setScopePicsModal_finished(false)} data={{
                                                    scopePic1: detailData.scopePic1_finished, 
                                                    scopePic2: detailData.scopePic2_finished, 
                                                    scopePic3: detailData.scopePic3_finished, 
                                                    scopePic4: detailData.scopePic4_finished, 
                                                    scopeNumber: detailData.scopeNumber, 
                                                    scopeEstimateAmount: detailData.scopeEstimateAmount,
                                                    scopeExpenses: detailData.scopeExpenses,
                                                    consultationID: props.data.consultationID
                                                    }}></ShowScopePicsModal>
                                                    <IonButton onClick={() => setScopePicsModal_finished(true)}> Add/View </IonButton>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol>
                                                    <h4>Scope Expenses</h4>
                                                </IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol>
                                                    <IonButton onClick={() => setShowAddExpenseModal(true)}> Add Expense </IonButton>
                                                </IonCol>
                                            </IonRow>
                                             <IonRow >
                                                        <IonCol size='3'> <h5> Supplier Name </h5> </IonCol>
                                                        {/*<IonCol className='appGridCol' size='2'> <h3> Supplier Phone </h3> </IonCol>*/}
                                                        {/*<IonCol className='appGridCol' size='3'> <h3> Expense Description </h3> </IonCol>*/}
                                                        <IonCol size='3'> <h5> Date Logged </h5> </IonCol>
                                                        <IonCol size='3'> <h5> Total Amount </h5> </IonCol>                                        
                                                        <IonCol size='3'> <h5> Action </h5> </IonCol>
                                                </IonRow>
                                            {detailData.scope_items.map((expenseData) =>   {
                                                return (
                                                        <IonRow key={expenseData.expenseID}>
                                                            <IonCol size='3'>{expenseData.supplierName}</IonCol>
                                                            {/*<IonCol className='appGridCol' size='2'>{detailData.supplierPhoneNumber}</IonCol>*/}
                                                            {/*<IonCol className='appGridCol' size='3'>{detailData.expenseDescription}</IonCol>*/}
                                                            <IonCol size='3'>{expenseData.dateLogged}</IonCol>
                                                            <IonCol size='3'>{expenseData.totalAmount}</IonCol>
                                                            <IonCol size='3'>

                                                                <IonButton className='appListButton' onClick={() => viewExpenseDetailsHandler([true, expenseData.expenseID, expenseData.totalAmount])}> Details </IonButton>
                                                               {/* {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonButton className='appListButton' onClick={() => viewDeleteExpenseHandler([true, expenseData.expenseID])}> Delete </IonButton>}
                                                                {/*<IonButton class='gridResultColumnButton' onClick={() => setViewAttachemntModal(true)}> View Invoice</IonButton>*/}
                                                        
                                                            </IonCol>
                                                        </IonRow>
                                                )
                                            }
                                            )}
                                        </IonGrid>

                        </IonSlide>
                        )
                   }
            )}
        </IonSlides>

                {showAddExpenseModal == true && <AddExpenseInvoiceModal openModal={ showAddExpenseModal } closeModal={() => setShowAddExpenseModal(false)} closeModal_update={() => props.closeModal_updateComplete()} data={{
                                        consultationID: props.data.consultationID, 
                                        }}></AddExpenseInvoiceModal>}
        </IonContent>


        <IonFooter className='grid_footer'>
            <IonGrid>
                {consultationStatus == "INITIAL" && <IonRow>
                    <IonCol>
                        <IonButton  onClick={() => send_customer_approvalRequest(props.data.consultationID)}> Send for Customer Approval </IonButton>
                    </IonCol>
                </IonRow>}
                {consultationStatus == "CUSTOMER_APPROVED" && <IonRow>
                    <IonCol>
                        <IonButton  onClick={() => add_consultationToProject(props.data.consultationID)}> Add To Project</IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton  onClick={() => convert_consultationToProject(props.data.consultationID)}> Convert To Project </IonButton>
                    </IonCol>
                </IonRow>}
                <IonRow>
                    <IonCol>
                        <IonButton onClick={closeModalHandler}> Close </IonButton>        
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonFooter>

    </IonModal>) : null}


    {showAddScopeModal == true && <AddScopeModal openModal={ showAddScopeModal } closeModal={() => setShowAddScopeModal(false)} data={{
                                            customerAccountID: props.data.customerAccountID, 
                                            consultationID: props.data.consultationID, 
                                            externalID: props.data.externalID,
                                            userStatus: props.data.userStatus,
                                            }}></AddScopeModal>}
    
    </React.Fragment>
    )
}